import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './shared/material.module';
import { AppComponent } from './app.component';
import { LeasingComponent } from './leasing/leasing.component';
import { LeasingService } from './leasing/leasing.service';
import { ChangeCriteriaDialogComponent } from './leasing/changeCriteriaDialog.component';
import { SummaryDialogComponent } from './leasing/summaryDialog.component';
import { FeedbackDialogComponent } from './leasing/feedbackDialog.component';
import { ChangeLocationDialogComponent } from './leasing/changeLocationDialog.component';
import { ChangeBudgetDialogComponent } from './leasing/changeBudgetDialog.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FirstClickBudgetDialogComponent } from './leasing/firstClickBudgetDialog.component';
import { UsedCarsNotAcceptedDialogComponent } from './leasing/usedCarsNotAcceptedDialog.component';

@NgModule({
    declarations: [
        AppComponent,
        LeasingComponent,
        ChangeCriteriaDialogComponent,
        ChangeLocationDialogComponent,
        ChangeBudgetDialogComponent,
        SummaryDialogComponent,
        FeedbackDialogComponent,
        FirstClickBudgetDialogComponent,
        UsedCarsNotAcceptedDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        MaterialModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxMatSelectSearchModule
    ],
    providers: [LeasingService],
    bootstrap: [AppComponent]
})
export class AppModule { }
